import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../Redux/cartSlice";
import {
  addToFavorites,
  removeFromFavorites,
} from "../../Redux/FavouriteSlice/favouriteSlice";
import { FaHeart } from "react-icons/fa"; // Heart icon
import "./style.css";
import { imageUrl } from "../../Config";
import { addToCart_db } from "../../Redux/db_Cart/db_cartSlice";

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const favorites = useSelector((state) => state.favorites.items);
  let token = localStorage.getItem("token");

  const isFavorite = favorites.some((fav) => fav.id === product.id);

  const toggleFavorite = () => {
    if (isFavorite) {
      dispatch(removeFromFavorites(product.id));
    } else {
      dispatch(addToFavorites(product));
    }
  };
  const addToCartProduct = (product) => {
    if (!token) {
      dispatch(addToCart(product));
    } else {
      dispatch(addToCart_db({ productId: product?.id, quantity: 1 }));
    }
  };

  const handleImageClick = () => {
    navigate("/product", { state: { product } });
  };

  return (
    <div className="col-lg-3 col-md-6 col-sm-12">
      <div className="product-card small_soap_text">
        <div
          className="sale_card"
          style={{
            backgroundColor: product.bgColor,
            position: "relative",
            overflow: "hidden",
            borderRadius: "10px",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
            marginBottom: "12px",
            aspectRatio: "1/1",
          }}
        >
          {/* Sale Badge */}
          <div
            style={{
              backgroundColor: "white",
              color: "#5D5B5B",
              width: 50,
              padding: "3px 14px",
              borderRadius: "15px",
              fontSize: "12px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              position: "absolute",
              top: "10px",
              left: "10px",
            }}
          >
            Sale!
          </div>
          <FaHeart
            className="heart-icon"
            onClick={toggleFavorite}
            style={{
              color: isFavorite ? "red" : "#ccc",
              fontSize: "20px",
              cursor: "pointer",
              position: "absolute",
              top: "10px",
              right: "10px",
              pointerEvents: "auto", // Explicitly set to ensure clickability
            }}
          />

          {/* Product Image with Hover Effect - Centered */}
          <img
            src={imageUrl + product?.imageUrl}
            alt={product.name}
            className="product-image"
            onClick={handleImageClick}
            style={{
              transition: "transform 0.3s ease",
              transformOrigin: "center",
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              ":hover": {
                transform: "scale(1.05)",
              },
            }}
          />
        </div>

        {/* Product Information Container */}
        <div style={{ textAlign: "left" }}>
          {/* Product Name */}
          <p
            style={{
              color: "#383838",
              fontSize: 14,
              fontWeight: 500,
              margin: "4px 0",
            }}
          >
            {product.name}
          </p>

          {/* Star Reviews */}
          {product.reviews && (
            <div style={{ margin: "4px 0" }}>
              <img src={product.reviews} alt="Reviews" />
            </div>
          )}

          {/* Product Description */}
          <p
            style={{
              color: "#777",
              fontSize: 11.5,
              overflow: "hidden",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
              margin: "4px 0",
              lineHeight: "1.3",
            }}
          >
            {product.description}
          </p>

          {/* Price */}
          <p
            style={{
              color: "#383838",
              fontSize: 14,
              fontWeight: 500,
              fontFamily: "Montserrat, sans-serif",
              margin: "8px 0",
            }}
          >
            Price: ${product.price}
          </p>

          <button
            className="add-to-cart-btn"
            onClick={() => addToCartProduct(product)}
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
